import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { paymentMethodStyles } from "@dana/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

paymentMethodStyles.container = mergeToNew(paymentMethodStyles.container, {
    css: css`
        @media print {
            margin-top: 20px;
            width: calc(33.3333% - 15px);
        }
    `,
});

paymentMethodStyles.paymentMethodTitleText = mergeToNew(paymentMethodStyles.paymentMethodTitleText, {
    css: css`
        margin-bottom: 0;
        padding: 16px;
        background: ${themeBackgrounds.lightGray};
        width: 100%;
    `,
});

paymentMethodStyles.paymentMethodTextWrapper = mergeToNew(paymentMethodStyles.paymentMethodTextWrapper, {
    css: css`
        padding: 16px;
        background: ${themeBackgrounds.white};
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
});
